import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/services/api-services/api.service';

@Component({
  selector: 'app-brand-widget',
  templateUrl: './brand-widget.component.html',
  styleUrls: ['./brand-widget.component.scss'],
})
export class BrandWidgetComponent implements OnInit {
  @Input() isExpanded: boolean = false;
  @Output() toggleExpanded = new EventEmitter<void>();
  brandImageSrc = null; // empty string means no logo provided by admin , null means we still didnt try to load the logo
  isLoading = true;
  showPlaceholder = false;
  placeholderMessage = 'Brand logo was not provided by your admin.';
  
  constructor(private apiService: ApiService) {}

  ngOnInit() {
    if(this.brandImageSrc == '') return;
    this.loadOrganisationLogo();
  }

  onToggleExpanded() {
    this.toggleExpanded.emit();
  }

  loadOrganisationLogo() {
    this.isLoading = true;
    this.showPlaceholder = false;
    this.apiService.getOrganisationInformation().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.brandLogoPath && response.brandLogoPath.trim() !== '') {
          this.brandImageSrc = response.brandLogoPath;
          this.showPlaceholder = false;
        } else {
          this.showPlaceholder = true;
          this.brandImageSrc = '';
        }
      },
      error: (error) => {
        console.error('Error loading organisation logo:', error);
        this.isLoading = false;
        this.showPlaceholder = true;
        this.brandImageSrc = '';
      }
    });
  }

  refreshBrandImage() {
    this.loadOrganisationLogo();
  }

  onImageError() {
    console.error('Error loading brand image');
    this.showPlaceholder = true;
    this.brandImageSrc = '';
  }
}
